import React, { useState } from 'react';
import { MenuIcon, XIcon } from 'lucide-react';
import { Link } from 'react-router-dom';
import { LazyCalendlyModal } from './LazyModals';
const links = [{
  label: 'Ablauf der Academy',
  to: '/ablauf-der-hot-sales-girls-academy'
}, {
  label: 'Über Tina',
  to: '/ueber-tina-xla'
}];
export function Navbar() {
  const [callOpen, setCallOpen] = useState(false);
  const [callPreload, setCallPreload] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  return <header className="relative z-50 w-full" data-id="element-334" data-mp="k4si4hkydjg">
      <nav aria-label="Hauptnavigation" className="gold-shimmer w-full border-b border-gold/40 bg-cream px-4 py-2 sm:px-6" data-id="element-335" data-mp="lfwo5extnb3">
        <div className="mx-auto flex w-full max-w-[1300px] items-center justify-between gap-4" data-id="element-336" data-mp="9kkx5ha27qpw">
          <div className="flex flex-1 items-center justify-start" data-id="element-337" data-mp="1pyb18o16iezj">
            <Link to="/" className="shrink-0" aria-label="Zur Startseite" data-id="element-338" data-mp="1q0nqznd6htn5">
              <img src="https://cdn.magicpatterns.com/uploads/tNLTDY1fCXiQ1zp6ggV3Ei/hot-sales-girls-academy-logo.webp" alt="Hot Sales Girls Academy Logo" className="h-9 w-9 rounded-full object-contain md:h-10 md:w-10" data-id="element-339" data-mp="1kyye026eb5wf" />
            </Link>
          </div>

          <ul className="hidden items-center justify-center gap-6 md:flex lg:gap-8" data-id="element-340" data-mp="jkkm0qn7xgdx">
            {links.map(link => <li key={link.to} data-id="element-341" data-mp="3n3dy0z0clx5z">
                <Link to={link.to} className="whitespace-nowrap text-sm font-semibold text-neutral-900 transition-colors hover:text-gold" data-id="element-342" data-mp="3n4f7x05modm4">
                  {link.label}
                </Link>
              </li>)}
          </ul>

          <div className="flex flex-1 items-center justify-end" data-id="element-343" data-mp="5n4ch69ml6hy">
            <button type="button" onClick={() => setCallOpen(true)} onMouseEnter={() => setCallPreload(true)} onFocus={() => setCallPreload(true)} className="btn-gold-shiny hidden rounded-full px-6 py-2.5 text-sm font-semibold md:inline-block" data-id="element-344" data-mp="34cw6gxr957m7">
              Kostenloses Gespräch buchen
            </button>

            <button type="button" onClick={() => setMenuOpen(open => !open)} aria-expanded={menuOpen} aria-controls="mobile-menu" aria-label={menuOpen ? 'Menü schließen' : 'Menü öffnen'} className="flex h-10 w-10 items-center justify-center rounded-full text-neutral-900 transition-colors hover:bg-neutral-100 md:hidden" data-id="element-345" data-mp="2wacbw3tag60h">
              {menuOpen ? <XIcon className="h-6 w-6" data-id="element-346" data-mp="2sb4ombso0bqg" /> : <MenuIcon className="h-6 w-6" data-id="element-347" data-mp="2sc69t93eaelw" />}
            </button>
          </div>
        </div>
      </nav>

      {menuOpen && <div id="mobile-menu" className="w-full border-b border-gold/40 bg-cream px-4 pb-4 pt-2 shadow-lg md:hidden" data-id="element-348" data-mp="2ndv151ou6a59">
          <ul className="flex flex-col" data-id="element-349" data-mp="2k80fva67ioz">
            {links.map(link => <li key={link.to} data-id="element-350" data-mp="a496z3rx9n6f">
                <Link to={link.to} onClick={() => setMenuOpen(false)} className="block border-b border-neutral-100 py-3 text-sm font-semibold text-neutral-900 transition-colors hover:text-gold" data-id="element-351" data-mp="a40v9f7jcnwt">
                  {link.label}
                </Link>
              </li>)}
          </ul>

          <button type="button" onClick={() => {
        setMenuOpen(false);
        setCallOpen(true);
      }} className="btn-gold-shiny mt-4 w-full rounded-full px-6 py-2.5 text-sm font-semibold" data-id="element-352" data-mp="surzk2co1o4c">
            Kostenloses Gespräch buchen
          </button>
        </div>}

      <LazyCalendlyModal open={callOpen} onClose={() => setCallOpen(false)} preload={callPreload} data-id="element-353" data-mp="o30eg7ca4all" />
    </header>;
}